import { USER_FIELD_KEYS } from "@hooks/use-get/users/types";
import { FieldsConfigResponse } from "@hooks/use-config-context/types";

// Fields that are read-only / system-managed and should never be sent in an update.
const READ_ONLY_KEYS = new Set([
  USER_FIELD_KEYS.ID,
  USER_FIELD_KEYS.WP_USER_ID,
  USER_FIELD_KEYS.BLOG_ID,
  USER_FIELD_KEYS.USER_EMAIL,
  USER_FIELD_KEYS.USER_LOGIN,
  USER_FIELD_KEYS.SYNC_SOURCE,
  USER_FIELD_KEYS.LAST_SYNCED_AT,
  USER_FIELD_KEYS.CREATED_AT,
  USER_FIELD_KEYS.UPDATED_AT,
]);

/**
 * Strips read-only fields and passes the remainder straight through.
 * The user REST endpoint accepts a flat payload.
 */
export const formatUserForSave = (
  toSave: Record<string, any>,
  _config: FieldsConfigResponse,
): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(toSave).filter(([key]) => !READ_ONLY_KEYS.has(key as any)),
  );
};
